import makeStyles from '@mui/styles/makeStyles';
import React from 'react';
import DescriptionIcon from '@mui/icons-material/Description';
import MapIcon from '@mui/icons-material/Map';
import MenuIcon from '@mui/icons-material/Menu';
import PersonIcon from '@mui/icons-material/Person';
import SettingsIcon from '@mui/icons-material/Settings';
import EngineeringIcon from '@mui/icons-material/Engineering';
import Paper from '@mui/material/Paper';

const useStyles = makeStyles({
  container: {
    alignSelf: 'center',
    background: 'none',
    cursor: 'pointer',
    display: 'flex',
    marginRight: '15px',
    backgroundColor: 'rgba(0, 0, 0, 0.6)',
    padding: '7px 7px 0px',
    boxShadow: 'none',
    borderRadius: '30px',
  },
  icon: {
    marginRight: '10px',
    color: 'white',
  },
  text: {
    textAlign: 'center',
    fontFamily: '"Helvetica Neue", Arial, sans-serif',
    fontSize: '14px',
    fontWeight: 'bold',
    textTransform: 'uppercase',
    color: 'white',
    paddingTop: '2px',
  },
});

const NavigationButton = ({ icon, text, onClick }) => {
  let IconComponent;
  const classes = useStyles();

  switch (icon) {
    case 'MenuIcon':
      IconComponent = MenuIcon;
      break;
    case 'PersonIcon':
      IconComponent = PersonIcon;
      break;
    case 'SettingsIcon':
      IconComponent = SettingsIcon;
      break;
    case 'MapIcon':
      IconComponent = MapIcon;
      break;
    case 'DescriptionIcon':
      IconComponent = DescriptionIcon;
      break;
    case 'EngineeringIcon':
      IconComponent = EngineeringIcon;
      break;
    default:
      IconComponent = null;
  }
  return (
    <Paper className={classes.container} onClick={onClick}>
      <div className={classes.icon}><IconComponent /></div>
      <div className={classes.text}>{text}</div>
    </Paper>
  );
};

export default NavigationButton;
